import * as Types from '../model/types';
import * as OpKinds from '../opKinds';
import * as Graph from '../graph';

const makeEntityOp = OpKinds.makeTaggingStandardOp;

const entityArgTypes = {
  entity: 'entity' as const,
};

const entityArgDescription = `A ${Graph.docType('entity')}`;

export const opEntityInternalId = makeEntityOp({
  hidden: true,
  name: 'entity-internalId',
  argTypes: entityArgTypes,
  description: `Returns the internalId of the ${Graph.docType('entity')}`,
  argDescriptions: {
    entity: entityArgDescription,
  },
  returnValueDescription: `The internalId of the ${Graph.docType('entity')}`,
  returnType: inputTypes => 'string',
  resolver: ({entity}) => {
    return entity.id;
  },
});

export const opEntityName = makeEntityOp({
  name: 'entity-name',
  argTypes: entityArgTypes,
  description: `Returns the name of the ${Graph.docType('entity')}`,
  argDescriptions: {
    entity: entityArgDescription,
  },
  returnValueDescription: `The name of the ${Graph.docType('entity')}`,
  returnType: inputTypes => 'string',
  resolver: ({entity}) => {
    return entity.name;
  },
});

export const opEntityLink = makeEntityOp({
  name: 'entity-link',
  argTypes: entityArgTypes,
  description: `Returns the link of the ${Graph.docType('entity')}`,
  argDescriptions: {
    entity: entityArgDescription,
  },
  returnValueDescription: `The link of the ${Graph.docType('entity')}`,
  returnType: inputTypes => 'link',
  resolver: ({entity}) => {
    return {
      name: entity.name,
      url: `/${entity.name}`,
    };
  },
});

export const opEntityProjects = makeEntityOp({
  hidden: true,
  name: 'entity-projects',
  argTypes: entityArgTypes,
  description: `Returns the ${
    (Graph.docType('project'), {plural: true})
  } of the ${Graph.docType('entity')}`,
  argDescriptions: {
    entity: entityArgDescription,
  },
  returnValueDescription: `The ${
    (Graph.docType('project'), {plural: true})
  } of the ${Graph.docType('entity')}`,
  returnType: inputTypes => Types.list('project'),
  resolver: ({entity}) => entity.projects.edges.map((edge: any) => edge.node),
});

export const opEntityArtifactPortfolios = makeEntityOp({
  hidden: true,
  name: 'entity-portfolios',
  argTypes: entityArgTypes,
  description: `Returns the ${Graph.docType(
    'artifact'
  )} portfolios of the ${Graph.docType('entity')}`,
  argDescriptions: {
    entity: entityArgDescription,
  },
  returnValueDescription: `The ${Graph.docType(
    'artifact'
  )} portfolios of the ${Graph.docType('entity')}`,
  returnType: inputTypes => Types.list('artifact'),
  resolver: ({entity}) =>
    (entity?.artifactPortfolios?.edges || []).map((n: any) => n.node),
});
